import { PlanType, ShiftType } from "../../types/shiftPlan";

/**
 * Convert display-friendly shift option value to API ShiftType
 */
export function getClockWindowNameBasedOnSelectedOption(selectedOption: string): ShiftType {
  if (selectedOption === "night") {
    return "NIGHT";
  }
  return "DAY";
}

/**
 * Convert tab selection value to API PlanType
 */
export function getPlanTypeBasedOnSelectedTab(selectedTab: string): PlanType {
  if (selectedTab === "sos") {
    return "PRE_SHIFT";
  } else if (selectedTab === "pdp") {
    return "NEXT_DAY";
  }
  return "PRE_SHIFT";
}
